import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'minsToTime' })
export class MinsToTimePipe implements PipeTransform {
  transform(mins: number): string {
    const h = (mins / 60) | 0;
    const m = mins % 60;
    return (
      (h > 12 ? h - 12 : h) +
      ':' +
      (m < 10 ? '0' + m : m) +
      (h > 11 ? ' PM' : ' AM')
    );
  }
}

@Pipe({ name: 'minsToDate' })
export class MinsToDatePipe implements PipeTransform {
  transform(mins: number): Date {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return new Date(d.getTime() + mins * 60000);
  }
}
